export function artifactToCompliancePayload(
  artifact
) {

  // Extract plain text from HTML
  const parser = new DOMParser();

  const doc = parser.parseFromString(
    artifact.html || "",
    "text/html"
  );

  const extractedText =
    doc.body.textContent || "";

  return {

    workflow_type:
      artifact.workflowType ||
      "incoming_inspection",

    transcript: extractedText,

    observation:
      artifact.title ||
      "Operational Event",

    evidence:
      (
        artifact.evidenceImages || []
      ).map(img => img.name),

    evidenceImages:
        artifact.evidenceImages || [],
    
    audioBase64:
      artifact.audioBase64 || null,
  };
}